module.exports = __webpack_public_path__ + "static/img/kkwslogo.ac0e0a08.png";